import { useState } from 'react';

const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const showModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return { isOpen, showModal, closeModal };
};

export default useModal;
